export class ciudades{
    constructor(){
        
    }
}